import React from 'react'
import { StartupDetail } from 'types/common'
import { StartupMap } from 'components/startup/startup-map'
import { EffortForDev } from 'components/startup/effort-for-dev'
import { SolvingProblem } from 'components/startup/solving-problem'
import { StartupStory } from 'components/startup/startup-story'
import { CompensationWelfare } from 'components/startup/compensation-welfare'
import { Team } from 'components/startup/team'
import { StartupPresentation } from 'components/startup/startup-presentation'
import { Column } from 'components/common/layout'
import { StartupImages } from 'components/startup/startup-images'
import { StartupFundingInfo } from 'components/startup/startup-funding-info'

export const StartupDetailInfo: React.FC<{
  data: StartupDetail
  width: number
}> = ({ data, width }) => {
  return (
    <Column style={{ gap: 80 }}>
      <SolvingProblem solvingProblem={data.solvingProblem} />
      <StartupImages images={data.images} width={width} />
      <StartupStory data={data} />
      {data.fundings && data.fundings.length > 0 && (
        <StartupFundingInfo
          fundings={data.fundings}
          reasonForInvesting={data.reasonForInvesting}
        />
      )}
      <EffortForDev effortForDev={data.effortForDev} />
      <CompensationWelfare
        compensation={data.compensation}
        welfare={data.welfare}
      />
      <Team
        culture={data.culture}
        members={data.members}
        memberHistory={data.memberHistory}
      />
      {data.pt && <StartupPresentation pt={data.pt} />}
      <StartupMap
        address={data.address}
        width={width}
        height={width * (9 / 16)}
      />
    </Column>
  )
}
